

import "./CourseOverview.css"

import { Link } from "react-router-dom";


import React, {useState} from 'react';




function CourseOverview() { 
 

  return <>
    <div className='courseOverCover' >
            <div className="courseHeading">
                <p>Choose a subject area:</p>

            </div>
        
           <div className='listOne'>    

                <button><Link className='linkItem' to={"/Courseswhole"}>  Marketing</Link></button> 
                              
                       
                <button><Link className='linkItem' to={"/Courseswhole"}>  Business Essentials </Link></button>
                <button><Link className='linkItem' to={"/Courseswhole"}>  Leadership & Management</Link></button>
                <button><Link className='linkItem' to={"/Courseswhole"}> Entreprenuership & Innovation</Link></button>

           </div>
           <div className='listOne'>    

                <button><Link className='linkItem' to={"/Courseswhole"}>  Strategy </Link></button>
                <button><Link className='linkItem' to={"/Courseswhole"}>  Finance & Accounting</Link></button>
                <button><Link className='linkItem' to={"/Courseswhole"}>  Business & Society </Link></button>
              

           </div>

        
                
    </div>
  
  </>
  
  ;
}

export default CourseOverview;